export const isSearchRequestDone = (status: string[]): boolean =>
  status.every((st) => ['pending', 'performing'].indexOf(st) === -1);

export const completedOperators = (status: string[]): number =>
  status.filter((item) => item === 'completed' || item === 'cached').length;
